import { singleline } from "@core/foundation/string";
import { apiEndpoint, publicApi } from "@core/ports/http";
import { z } from "@core/zod";

import { API_DOMAIN } from "@platform/core";

import { ACCOUNT_SERVICE } from "../config/index.ts";

export const authApi = publicApi(
  { domain: API_DOMAIN, path: `${ACCOUNT_SERVICE.LABEL}/auth` },
  {
    authCallback: apiEndpoint("GET", {
      queryParams: z.object(
        { code: z.string(), state: z.string() },
        {
          code: "The authorization code Cognito returns",
          state:
            "The JSON-encoded return URL and session passed through Cognito",
        },
      ),
      response: z.void(),
    }),
    getAuthRedirectUrl: apiEndpoint({
      body: z.object(
        { returnUrl: z.url(), session: z.safeId() },
        {
          returnUrl: "The app URL the auth callback redirects to with the code",
          session: singleline`
            The sign-in session the app started, passed back to the return URL
          `,
        },
      ),
      response: z.object(
        { redirectUrl: z.url() },
        { redirectUrl: "The Cognito sign-in URL to send the browser to" },
      ),
    }),
    getAuthToken: apiEndpoint({
      body: z.object(
        {
          code: z.string(),
          // oxlint-disable-next-line custom/no-dangerous-operations
          dangerouslyRequestAdminRole: z.boolean().optional(),
        },
        {
          code: "The authorization code the auth callback passed to the app",
          // oxlint-disable-next-line custom/no-dangerous-operations
          dangerouslyRequestAdminRole:
            "Whether to sign in as an admin, refused for a non-admin account",
        },
      ),
      response: z.object(
        { authToken: z.string() },
        { authToken: "The auth token issued to the signed-in user" },
      ),
    }),
  },
);
